import { render, staticRenderFns } from "./ProvidedQuotaSourceUsageBar.vue?vue&type=template&id=124b04e4"
import script from "./ProvidedQuotaSourceUsageBar.vue?vue&type=script&lang=js"
export * from "./ProvidedQuotaSourceUsageBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports